import type React from "react";
import { SHOP_INFO } from "../config";

const Header: React.FC = () => {
  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="temomi-header fixed top-0 w-full z-50 transition-all duration-300 bg-white/90 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex justify-between items-center">
        {/* Logo */}
        <button
          type="button"
          className="flex items-center gap-3 md:gap-4 cursor-pointer bg-transparent border-0 p-0 focus:outline-none group"
          onClick={handleLogoClick}
        >
          <img
            src={`${SHOP_INFO.basePath}/logo.webp`}
            alt="手もみ王ロゴ"
            className="h-8 w-8 md:h-12 md:w-12 object-contain drop-shadow-sm transition-transform group-hover:scale-105"
            loading="lazy"
          />
          <div className="flex flex-col items-start text-left">
            <span className="text-[10px] md:text-xs text-gray-500 font-medium tracking-wider mb-0.5">
              リラクゼーションサロン
            </span>
            <span className="text-sm md:text-xl font-bold text-gray-800 leading-none tracking-tight group-hover:text-[var(--temomi-red)] transition-colors">
              {SHOP_INFO.name}
            </span>
          </div>
        </button>

        {/* Actions */}
        <div className="flex items-center gap-3 md:gap-6">
          {/* Phone Button */}
          <a
            href={`tel:${SHOP_INFO.phone}`}
            className="flex items-center justify-center w-10 h-10 md:w-auto md:h-auto md:px-4 md:py-2 rounded-full border border-[var(--temomi-red)] text-[var(--temomi-red)] hover:bg-[var(--temomi-red)] hover:text-white transition-all duration-300"
            aria-label="電話をかける"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-5 h-5 md:mr-2"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                clipRule="evenodd"
              />
            </svg>
            <span className="hidden md:inline font-bold">
              {SHOP_INFO.phone}
            </span>
          </a>

          {/* Reservation Button */}
          <a
            href={SHOP_INFO.reservationUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-all duration-300 px-4 py-2 md:px-6 md:py-3 rounded-full bg-gradient-to-r from-[var(--temomi-red)] to-orange-500 text-white font-bold shadow-md hover:shadow-lg hover:from-red-600 hover:to-orange-600 transform hover:-translate-y-0.5 text-xs md:text-base flex items-center gap-1 md:gap-2"
          >
            <span className="hidden md:inline">WEB</span>
            予約
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="w-4 h-4"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm-1 5a1 1 0 011-1h14a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V9zm10 3a1 1 0 11-2 0 1 1 0 012 0zm-6 0a1 1 0 11-2 0 1 1 0 012 0z"
                clipRule="evenodd"
              />
            </svg>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
